import { Sections, usePage } from "../../hooks/usePage";
import { Loading, PageHero, QuoteBand, RichText, SectionHeading } from "../../components/site/Blocks";
import { mediaSrc } from "../../lib/api";

const Intro = ({ data }) => (
  <>
    <PageHero eyebrow={data.eyebrow} title={data.heading} testid="about-hero" />
    <section className="py-16" data-testid="about-intro">
      <div className="container-site grid items-center gap-12 lg:grid-cols-2">
        <RichText html={data.body} />
        {data.image_url && <img src={mediaSrc(data.image_url)} alt={data.image_alt || ""} className="aspect-[4/3] w-full rounded-lg object-cover" />}
      </div>
    </section>
  </>
);

const Mission = ({ data }) => (
  <section className="bg-paleblue py-16" data-testid="about-mission">
    <div className="container-site max-w-4xl">
      <SectionHeading title={data.heading} />
      <RichText html={data.body} className="mt-5" />
    </div>
  </section>
);

const RENDER = { intro: Intro, mission: Mission, quote: QuoteBand };

export default function About() {
  const { page, loading } = usePage("about");
  if (loading) return <Loading />;
  return <div data-testid="about-page"><Sections page={page} render={RENDER} /></div>;
}
